import * as React from 'react';
import { CodeSnippetsVisualStore } from '../stores/CodeSnippetsVisualStore';
import { observer } from 'mobx-react-lite';
import { CodeSnippet } from '../models';
import { Spin } from 'antd';
import MdEditor from 'react-markdown-editor-lite';
import MarkdownIt from 'markdown-it';
import CSharpCodeEditor from '../../iota_applications/components/CSharpCodeEditor';

type Props = {
    store: CodeSnippetsVisualStore;
};

const CodeSnippetPreview: React.FC<Props> = ({ store }) => {
    const [isLoading, setIsLoading] = React.useState(true);

    if (!store.previewItem) {
        return null;
    }

    const mdParser = new MarkdownIt();
    const previewSnippet = store.previewItem as CodeSnippet;

    const handleEditorReady = () => {
        setIsLoading(false);
    };

    return (
        <>
            <div style={{ margin: '12px 0' }}>
                <span style={{ fontWeight: 500, fontSize: 22 }}>{previewSnippet.name}</span>
                <span style={{ fontWeight: 500, fontSize: 22 }}>&nbsp;[{previewSnippet.type}]</span>
            </div>
            {!store.formDialogVisible && (
                <Spin tip="Loading..." spinning={isLoading}>
                    <CSharpCodeEditor
                        height="400"
                        onReady={handleEditorReady}
                        value={previewSnippet.code}
                        readOnly
                        snippets={store.codeSnippets}
                    />
                </Spin>
            )}

            <div style={{ margin: '12px 0', color: '#9BA0AA', fontSize: 11 }}>Description</div>
            <MdEditor
                style={{ height: 'calc(100% - 560px)', borderRadius: 4 }}
                name="code-snippet-description"
                renderHTML={text => mdParser.render(text.toString())}
                value={previewSnippet.description || ''}
                config={{ view: { md: false, html: true, menu: false } }}
            />
        </>
    );
};

export default observer(CodeSnippetPreview);
